// // import axios from "axios";
// // import toast from "react-hot-toast";

// // let Promise = require("promise");

// // export const loadScript = (src) => {
// //   return new Promise((resolve) => {
// //     const script = document.createElement("script");
// //     script.src = src;
// //     script.onload = () => {
// //       resolve(true);
// //     };
// //     script.onerror = () => {
// //       resolve(false);
// //     };
// //     document.body.appendChild(script);
// //   });
// // };

// // const axiosInstance = axios.create({
// //   baseURL: "https://api.unlock.fit/", //production
// //   // baseURL: "https://dev-api.unlock.fit/", //dev
// //   // baseURL: "https://z5d9jm6x-4002.inc1.devtunnels.ms/", //local
// // });

// // export const displayRazorpay = async (
// //   userId,
// //   Products,
// //   Data,
// //   planId,
// //   dnaInclude,
// //   DnaProducts,
// //   Total,
// //   setSteps,
// //   setSuccess,
// //   Success,
// //   Steps,
// //   setPaymentMessage,
// //   setProgress
// // ) => {
// //   // console.log(
// //   //   "total",
// //   //   total,
// //   //   "userId",
// //   //   userId,
// //   //   "formValues",
// //   //   formValues,
// //   //   "allpurchase",
// //   //   allpurchase,
// //   //   "familyArray",
// //   //   familyArray
// //   // );
// //   const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
// //   if (!res) {
// //     alert("Razorpay SDK failed to load. Are you online?");
// //     return;
// //   }

// //   const tots = Total;

// //   const options = {
// //     // key: process.env.REACT_APP_PUBLIC_RAZORPAY,
// //     key: "rzp_live_TpYaDdpuUOV5dp", //live
// //     // key: "rzp_test_7PIqewalPNv3tL", //test
// //     // key: "rzp_test_0q14YMbTB7KoVy", //test
// //     currency: "INR",
// //     amount: dnaInclude === "true" ? tots * 100 : Products?.special_price * 100,
// //     // amount: 100,
// //     handler: async (response) => {
// //       console.log(response);
// //       setProgress(true);
// //       // let body = {
// //       //   plan_id: formValues[0].plan_id,
// //       //   userId: userId,
// //       //   plan_price: formValues[0].price,
// //       //   orderId: response.razorpay_payment_id,
// //       //   allpurchase: allpurchase,
// //       //   family: familyArray,
// //       // };
// //       // if (formValues[0].duration_id) {
// //       //   body.duration_id = formValues[0].duration_id;
// //       // }
// //       let body = {
// //         plan_id: Products?.id,
// //         user_id: userId,
// //         plan_price: Products?.special_price,
// //         orderid: response.razorpay_payment_id,
// //         duration_id: Products?.durations[0].id ? Products?.durations[0].id : "",
// //         is_dna_pro_included: dnaInclude,
// //         ...(dnaInclude === "true" && {
// //           dna_pro_details: {
// //             plan_id: DnaProducts.id,
// //             plan_price: DnaProducts.special_price,
// //           },
// //         }),
// //       };
// //       console.log("body", body);
// //       try {
// //         axiosInstance
// //           // .post(`website/user/buySubcriptionPlan`, body)
// //           .post(`website/v1/buySubscription`, body)
// //           .then((val) => {
// //             // toast("Payment Successful 🤗", { type: "success" });
// //             const message = val.data.data[0].message;
// //             setSuccess({ ...Success, payment: true });
// //             setProgress(false);
// //             setSteps({
// //               ...Steps,
// //               details: "done",
// //               payment: "done",
// //               test: "inactive",
// //             });
// //             console.log("first", message);
// //             setPaymentMessage(message);
// //             // let url = `/contactPage/?userId=${userId}`;
// //             // let url = "https://www.unlock.fit/";
// //             // window.location.href = url;
// //           })
// //           .catch((err) => {
// //             setProgress(false);
// //             const errors = err.response.data;
// //             toast.error(errors.message);
// //           });
// //       } catch (err) {
// //         console.log(err);
// //         setProgress(false);
// //         alert(err.response.message);
// //       }
// //     },
// //     prefill: {
// //       contact: Data.phone,
// //       email: Data.email,
// //     },
// //   };
// //   console.log("key", options);
// //   const paymentObject = new window.Razorpay(options);
// //   paymentObject.open();
// //   console.log(paymentObject);
// // };


// import axios from "axios";
// import toast from "react-hot-toast";

// /**
//  * Load Razorpay script
//  * ❌ DO NOT override native Promise
//  */
// export const loadScript = (src) => {
//   return new Promise((resolve) => {
//     const script = document.createElement("script");
//     script.src = src;
//     script.onload = () => resolve(true);
//     script.onerror = () => resolve(false);
//     document.body.appendChild(script);
//   });
// };

// /**
//  * Axios instance
//  */
// const axiosInstance = axios.create({
//   baseURL: "https://api.unlock.fit/", // production
//   // baseURL: "https://dev-api.unlock.fit/", // dev
//   // baseURL: "http://localhost:4002/", // local
// });

// /**
//  * Razorpay Payment
//  */
// export const displayRazorpay = async (
//   userId,
//   Products,
//   Data,
//   planId,
//   dnaInclude,
//   DnaProducts,
//   Total,
//   setSteps,
//   setSuccess,
//   Success,
//   Steps,
//   setPaymentMessage,
//   setProgress
// ) => {
//   try {
//     setProgress(true);

//     // Load Razorpay SDK
//     const res = await loadScript(
//       "https://checkout.razorpay.com/v1/checkout.js"
//     );

//     if (!res) {
//       setProgress(false);
//       toast.error("Razorpay SDK failed to load. Are you online?");
//       return;
//     }

//     const amount =
//       dnaInclude === "true"
//         ? Number(Total)
//         : Number(Products?.special_price);

//     if (!amount) {
//       setProgress(false);
//       toast.error("Invalid payment amount");
//       return;
//     }

//     const options = {
//       key: "rzp_live_TpYaDdpuUOV5dp", // LIVE
//       // key: "rzp_test_7PIqewalPNv3tL", // TEST

//       currency: "INR",
//       amount: amount * 100,
//       name: "Unlock.fit",
//       description: "Subscription Payment",

//       handler: async (response) => {
//         try {
//           console.log("Razorpay response:", response);

//           const body = {
//             plan_id: Products?.id,
//             user_id: userId,
//             plan_price: Products?.special_price,
//             orderid: response.razorpay_payment_id,
//             duration_id: Products?.durations?.[0]?.id || null,
//             is_dna_pro_included: dnaInclude,
//             ...(dnaInclude === "true" && {
//               dna_pro_details: {
//                 plan_id: DnaProducts?.id,
//                 plan_price: DnaProducts?.special_price,
//               },
//             }),
//           };

//           console.log("Subscription body:", body);

//           const { data } = await axiosInstance.post(
//             "website/v1/buySubscription",
//             body
//           );

//           const message =
//             data?.data?.[0]?.message || "Payment successful";

//           toast.success("Payment Successful 🤗");

//           setSuccess({ ...Success, payment: true });

//           setSteps({
//             ...Steps,
//             details: "done",
//             payment: "done",
//             test: "inactive",
//           });

//           setPaymentMessage(message);
//           setProgress(false);
//         } catch (err) {
//           console.error("Subscription API error:", err);
//           setProgress(false);
//           toast.error(
//             err?.response?.data?.message ||
//               "Payment done but subscription failed"
//           );
//         }
//       },

//       prefill: {
//         contact: Data?.phone || "",
//         email: Data?.email || "",
//       },

//       modal: {
//         ondismiss: () => {
//           setProgress(false);
//           toast.error("Payment cancelled");
//         },
//       },

//       theme: {
//         color: "#0f766e",
//       },
//     };

//     const paymentObject = new window.Razorpay(options);
//     paymentObject.open();
//   } catch (error) {
//     console.error("Razorpay init error:", error);
//     setProgress(false);
//     toast.error("Unable to initiate payment");
//   }
// };

import axios from "axios";
import toast from "react-hot-toast";
import { GlobalVar } from "./newIndex";

/**
 * Load Razorpay script
 * ✅ DO NOT override native Promise
 */
export const loadScript = (src) => {
  return new Promise((resolve) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      return resolve(true);
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;

    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);

    document.body.appendChild(script);
  });
};

/**
 * Axios instance (unchanged)
 */
const axiosInstance = axios.create({
  baseURL: "https://api.unlock.fit/", // production
});

/**
 * Razorpay Payment
 */
export const displayRazorpay = async (
  userId,
  Products,
  Data,
  planId,
  dnaInclude,
  DnaProducts,
  Total,
  setSteps,
  setSuccess,
  Success,
  Steps,
  setPaymentMessage,
  setProgress
) => {
  try {
    // 🚫 DO NOT set progress yet
    setPaymentMessage("Loading payment gateway...");

    const sdkLoaded = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!sdkLoaded) {
      toast.error("Razorpay SDK failed to load");
      return;
    }

    const amount =
      dnaInclude === "true"
        ? Number(Total)
        : Number(Products?.special_price);

    if (!amount || amount <= 0) {
      //toast.error("Invalid payment amount");

      const body = {
        plan_id: Products?.id,
        user_id: userId,
        coupon_id: GlobalVar.coupon_id ?? null,
        plan_price: 0,
        orderid: "100% Coupon",
        duration_id: Products?.durations?.[0]?.id || null,
        is_dna_pro_included: dnaInclude,
        ...(dnaInclude === "true" && {
          dna_pro_details: {
            plan_id: DnaProducts?.id,
            plan_price: DnaProducts?.special_price,
          },
        }),
      };

      const { data } = await axiosInstance.post(
        "website/v1/buySubscriptionFree",
        body
      );

      const message =
        data?.data?.[0]?.message || "Payment successful";

      toast.success("Payment Successful 🤗");

      GlobalVar.coupon_id = null;

      setSuccess({ ...Success, payment: true, paymentFree: true });

      setSteps({
        ...Steps,
        details: "done",
        payment: "done",
        test: "inactive",
      });

      setPaymentMessage(message);
      return;
    }

    const options = {
      key: "rzp_live_TpYaDdpuUOV5dp", // LIVE KEY (as requested)
      currency: "INR",
      amount: Math.round(amount * 100),

      name: "Unlock.fit",
      description: "Subscription Payment",

      handler: async (response) => {
        setProgress(true);
        setPaymentMessage("Finalizing your subscription...");

        try {
          console.log("Razorpay success:", response);

          const body = {
            plan_id: Products?.id,
            user_id: userId,
            coupon_id: GlobalVar.coupon_id ?? null,
            plan_price: Products?.special_price,
            orderid: response.razorpay_payment_id,
            duration_id: Products?.durations?.[0]?.id || null,
            is_dna_pro_included: dnaInclude,
            ...(dnaInclude === "true" && {
              dna_pro_details: {
                plan_id: DnaProducts?.id,
                plan_price: DnaProducts?.special_price,
              },
            }),
          };

          const { data } = await axiosInstance.post(
            "website/v1/buySubscription",
            body
          );

          const message =
            data?.data?.[0]?.message || "Payment successful";

          toast.success("Payment Successful 🤗");

          GlobalVar.coupon_id = null;

          setSuccess({ ...Success, payment: true });

          setSteps({
            ...Steps,
            details: "done",
            payment: "done",
            test: "inactive",
          });

          setPaymentMessage(message);
        } catch (err) {
          console.error("Subscription API failed:", err);
          toast.error(
            err?.response?.data?.message ||
            "Payment succeeded but subscription failed"
          );
        } finally {
          setProgress(false);
        }
      },

      modal: {
        ondismiss: () => {
          setProgress(false);
          setPaymentMessage("");
          toast.error("Payment cancelled");
        },
      },

      prefill: {
        contact: Data?.phone || "",
        email: Data?.email || "",
      },

      theme: {
        color: "#0f766e",
      },
    };

    const razorpay = new window.Razorpay(options);

    // ✅ VERY IMPORTANT: catch failures
    razorpay.on("payment.failed", (response) => {
      console.error("Payment failed:", response.error);
      setProgress(false);
      setPaymentMessage("");
      toast.error(response.error.description || "Payment failed");
    });

    // ✅ Safety fallback (prod only)
    setTimeout(() => {
      setProgress(false);
    }, 60000);

    razorpay.open();
  } catch (error) {
    console.error("Razorpay init error:", error);
    setProgress(false);
    toast.error("Unable to initiate payment");
  }
};

